import { Switch } from 'antd'
import Select from 'components/UI/Select'
import { useAuth } from 'context/AuthProvider'
import { useI18n } from 'context/I18nProvider'
import type { Option } from 'shared/types'

interface CascadeProps {
  value?: string | boolean | undefined
  onChange: (e: boolean) => void
  className?: string
}

/** @todo unify CascadeSwitch & CascadeSelect */
export default function CascadeSwitch({ value, onChange, className = '' }: CascadeProps) {
  const { i18n } = useI18n()

  return (
    <div className={`w-full flex justify-between items-center my-3 ${className}`}>
      <div className="text-(--primary)">N-1</div>
      <Switch checked={Boolean(value)} onChange={onChange} />
      <div className="">{i18n('label.cascade_new')}</div>
    </div>
  )
}

interface CascadeSelectProps {
  value: string
  onChange: Function
}

export function CascadeSelect({ value, onChange, ...props }: CascadeSelectProps) {
  const { i18n } = useI18n()
  const { user } = useAuth()

  const options = [
    ...(user?.perimeter?.['n-1']
      ? [
          {
            label: i18n('label.team-1'),
            value: 'false',
          },
        ]
      : []),
    ...(user?.perimeter?.['n-X']
      ? [
          {
            label: i18n('label.hierarchical_cascade'),
            value: 'true',
          },
        ]
      : []),
  ]

  if (options.length < 2) return null

  return (
    <Select
      value={options.find(o => o.value === value)}
      onChange={onChange}
      options={options.map((o: Option) => ({ label: o.label, value: o.value }))}
      placeholder={i18n('label.perimeters')}
      {...props}
    />
  )
}
